class AssignSimsToBrandModalController {
    constructor(UtpBrandServiceApi, toastr) {
        this.$onInit = () => {
            this.init();
        };
        this.save = () => {
            // Save changes to existing brand or a newly defined one to the
            // database via the web api
            this.UtpBrandServiceApi.saveBrandDTO(this.brand).then((response) => {
                // ensure we have a response
                let saveResponse = response.data;
                if (!angular.isUndefined(saveResponse)) {
                    // If there are errors, then act
                    if (saveResponse.errors.length > 0) {
                        this.validationErrors = saveResponse.errors;
                        angular.forEach(this.validationErrors, (validationError) => {
                            this.toastr.error(validationError);
                            // console.log(validationError);
                        });
                        return;
                    }
                    // Simulator Added and now we close the modal.
                    this.close();
                }
                else {
                    // should never happen but may cause issues when we hang the timeout during debugging -
                    // this will handle the case where users experience a slow response and the timeout is hit.
                    console.log('Broken Response - No data returned?');
                    this.toastr.info('Error saving details please double check all mandatory fields are completed.');
                }
            });
        };
        this.cancel = () => {
            // Cancel the page without any changes
            this.dismiss();
        };
        this.assignSim = (assignSim) => {
            // Add the new sim to the Assigned List and then order the list by sim.Name
            this.brand.AssignedSimulators = _.sortBy(this.brand.AssignedSimulators.concat([assignSim]), (sim) => {
                return sim.Name;
            });
            // Remove the sim from the Available List
            _.remove(this.data.availableSims, (sim) => {
                return sim.Id === assignSim.Id;
            });
        };
        this.unassignSim = (removeSim) => {
            // Add the new sim to the Available List and then order the list by sim.Name
            this.data.availableSims = _.sortBy(this.data.availableSims.concat([removeSim]), (sim) => {
                return sim.Name;
            });
            // Remove the sim from the Assigned List
            _.remove(this.brand.AssignedSimulators, (sim) => {
                return sim.Id === removeSim.Id;
            });
        };
        this.init = () => {
            this.data = {
                action: 'Create',
                availableSims: []
            };
            let params = this.resolve;
            this.data.availableSims = params.availableSims;
            this.brand = params.brand;
            this.data.action = 'Create';
        };
        this.UtpBrandServiceApi = UtpBrandServiceApi;
        this.toastr = toastr;
    }
}
angular.module('app').component('assignSimsToBrandModalComponent', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Brand/assign-sims-to-brand.tpl.html',
    controllerAs: 'vm',
    controller: AssignSimsToBrandModalController
});
